import { layoutProcess } from 'bpmn-auto-layout';

/**
 * Auto-generate visual DI (diagram interchange) for BPMN XML that has no
 * BPMNShape elements.  Uses bpmn-auto-layout to produce positions.
 * Falls back to the original XML if layout generation fails.
 */
export async function ensureLayout(xml) {
  if (!xml || /<bpmndi:BPMNShape/i.test(xml)) {
    return xml;
  }
  console.log('[ensureLayout] No BPMNShape elements found \u2013 generating auto-layout');
  try {
    return await layoutProcess(xml);
  } catch (err) {
    console.warn('[ensureLayout] Auto-layout failed, using original XML:', err);
    return xml;
  }
}
